module.exports = __webpack_public_path__ + "img/style.e7e83453.png";